import { render, staticRenderFns } from "./ListRechazos.vue?vue&type=template&id=0e5e8e0a&"
import script from "./ListRechazos.vue?vue&type=script&lang=js&"
export * from "./ListRechazos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports